@if (data(); as node) {
  <!-- `selectable` (SelectableDirective) es OBLIGATORIO en nodos de tipo componente: sin
       él ngx-vflow no emite `nodesChanges.select` y no habría resaltado ni selección. -->
  <div
    selectable
    class="w-64 rounded-xl border border-l-4 bg-white shadow-sm transition-shadow dark:bg-gray-900"
    [class]="meta()?.accentClass"
    [class.border-gray-200]="!selected()"
    [class.dark:border-gray-800]="!selected()"
    [class.border-brand-500]="selected()"
    [class.shadow-lg]="selected()"
    [class.ring-2]="selected()"
    [class.ring-brand-500/40]="selected()"
    [class.opacity-60]="!node.isActive">

    <!-- Puerto de entrada: acepta N conexiones. El TRIGGER no lo tiene (salvo herencia).

         ARRIBA, no a la izquierda: el flujo se construye en vertical (cada paso debajo del
         anterior). Con la entrada a la izquierda y la salida a la derecha, cada arista tenía que
         salir por un lado, rodear el nodo y volver a entrar por el otro, dibujando una "U" que
         con tres pasos ya se leía mal. -->
    @if (showTargetHandle()) {
      <handle position="top" type="target" [id]="targetHandleId" />
    }

    <div class="flex items-start gap-3 px-3 pt-3 pb-2">
      <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm"
            [class]="meta()?.iconClass">
        <i [class]="meta()?.icon"></i>
      </span>
      <div class="min-w-0 flex-1">
        <p class="truncate text-sm font-semibold text-gray-800 dark:text-white/90" [title]="displayTitle()">
          {{ displayTitle() }}
        </p>
        <p class="truncate text-xs text-gray-500 dark:text-gray-400" [title]="node.summary">
          {{ node.summary }}
        </p>
      </div>
    </div>

    @if (node.nodeType === 'TRIGGER' || node.nodeType === 'END' || !node.isActive || node.incomplete) {
      <div class="flex flex-wrap gap-1 px-3 pb-2">
        @if (node.nodeType === 'TRIGGER') {
          <span class="rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-500/20 dark:text-blue-400">
            Inicio
          </span>
        }
        @if (node.nodeType === 'END') {
          <span class="rounded-full bg-rose-100 px-2 py-0.5 text-[10px] font-medium text-rose-700 dark:bg-rose-500/20 dark:text-rose-400">
            Fin
          </span>
        }
        @if (!node.isActive) {
          <span class="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">
            Inactivo
          </span>
        }
        @if (node.incomplete) {
          <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-700 dark:bg-amber-500/20 dark:text-amber-400"
                title="Este nodo tiene configuración pendiente. Puedes guardarlo igualmente.">
            <i class="fa-solid fa-triangle-exclamation mr-1"></i>Incompleto
          </span>
        }
      </div>
    }

    <!-- Un puerto de salida por rama. El puerto ES el branchKey de la arista que nazca.

         Las ramas van en FILA sobre el borde inferior (y no apiladas a la derecha) para que cada
         puerto quede justo debajo de su etiqueta: así "Sí" y "No" salen hacia abajo, cada uno por
         su lado, en vez de nacer los dos del costado derecho a distinta altura. `flex-wrap` cubre
         los nodos con muchas ramas (MULTI_BRANCH, AB_SPLIT). -->
    @if (node.handles.length) {
      <div class="flex flex-wrap items-stretch justify-around gap-x-2 border-t border-gray-100 dark:border-gray-800">
        @for (handle of node.handles; track trackHandle($index, handle)) {
          <div class="relative flex min-w-0 flex-1 flex-col items-center gap-1 px-2 pb-2 pt-1.5 text-xs text-gray-600 dark:text-gray-400">
            <span class="max-w-full truncate" [title]="handle.description">{{ handle.label }}</span>
            <span class="h-2 w-2 shrink-0 rounded-full" [class]="handle.dotClass"></span>
            <handle position="bottom" type="source" [id]="handle.branchKey" />
          </div>
        }
      </div>
    } @else if (node.nodeType !== 'END' && node.nodeType !== 'ANNOTATION' && !node.orphanBranchKeys.length) {
      <div class="border-t border-gray-100 px-3 py-1.5 text-xs text-gray-400 dark:border-gray-800 dark:text-gray-500">
        Sin salidas configuradas
      </div>
    }

    <!-- Ramas que ya no son puerto real del nodo (se quitaron del config): se conservan y
         se pueden ver/borrar a mano. UN solo puerto huérfano para no duplicar handle ids. -->
    @if (node.orphanBranchKeys.length) {
      <div class="relative flex items-center justify-end gap-2 border-t border-amber-200 bg-amber-50/60 px-3 py-1.5 dark:border-amber-500/30 dark:bg-amber-500/10">
        <span class="truncate text-xs text-amber-700 dark:text-amber-400"
              [title]="'Ramas conservadas, no editables como puerto: ' + node.orphanBranchKeys.join(', ')">
          <i class="fa-solid fa-link mr-1 text-[10px]"></i>
          {{ node.orphanBranchKeys.length }} {{ node.orphanBranchKeys.length === 1 ? 'rama conservada' : 'ramas conservadas' }}
        </span>
        <span class="h-2 w-2 shrink-0 rounded-full bg-amber-500"></span>
        <handle position="bottom" type="source" [id]="orphanHandleId" />
      </div>
    }
  </div>
}
